import ArticleCard from 'components/ArticleCard';
import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import MaxWidthWrapper from 'components/wrappers/MaxWidthWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import { mediaQueries } from 'config/theme/breakpoints';
import useAboveBreakpoint from 'hooks/useAboveBreakpoint';

const ArticleGridLayout = ({ articles = [] }) => {
    const isAboveSm = useAboveBreakpoint('sm');

    return articles.length > 0 ? (
        <MaxWidthWrapper includeContentMargins mt={['48px', null, '64px']}>
            <ColumnsLayout
                blocks={articles.map((article, index) => {
                    const { backgroundLandscape, backgroundPortrait, date, heading, id, category, to } = article;
                    const wideArticleCard = (index + 1) % 4 === 0; // Every fourth card and only from tablet breakpoint

                    return (
                        <ArticleCard
                            category={category}
                            categoryAndDateStyles={{ width: wideArticleCard ? ['100%', null, '33.33%'] : '100%' }}
                            columnStyles={{ display: 'flex', alignItems: 'flex-end' }}
                            date={date}
                            heading={heading}
                            image={isAboveSm && wideArticleCard ? backgroundLandscape : backgroundPortrait}
                            imageStyles={
                                isAboveSm &&
                                wideArticleCard && {
                                    position: 'absolute',
                                    left: '50%',
                                    transform: 'translateX(-50%)', // Makes wide cards bleed outside content margins
                                    marginBottom: '12px',
                                    width: '100vw',
                                }
                            }
                            key={id}
                            mediaQuery={wideArticleCard ? mediaQueries.fullWidth : mediaQueries.threeColumn}
                            ratio={isAboveSm && wideArticleCard ? 16 / 9 : 3 / 4}
                            size={wideArticleCard ? 12 : undefined}
                            to={to}
                        />
                    );
                })}
                columnSizes={[12, null, 4]}
                gutterWidth={[12, null, null, 24]}
                gutterHeight={56}
            />
        </MaxWidthWrapper>
    ) : null;
};

ArticleGridLayout.propTypes = {
    articles: PropTypes.array,
};

export default ArticleGridLayout;
